import { render, staticRenderFns } from "./KnProductOptions.vue?vue&type=template&id=54004d7c&"
import script from "./KnProductOptions.vue?vue&type=script&lang=js&"
export * from "./KnProductOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports